<div class="l-main__contents">
    <div id="wrapper">
        <div class="c-text-1 h-margin-b24">{{ title }}</div>
        <div class="grid-area">
            <div class="loading" *ngIf="loading">
                <app-loading-circle></app-loading-circle>
            </div>
            <div class="cassette-list-header">
                <a class="goto-area" (click)="gotoArea()"> エリア選択に戻る </a>
                <a class="goto-cassette-list" (click)="gotoCassetteList()"> カセット一覧（ファイルUL・DL・削除）へ </a>
            </div>
            <is-igx-mapping
                *ngIf="!loading"
                [environmentKey]="environmentKey"
                [frontEndParams]="mappingParams"
                [frontEndHubParams]="hubParams"
            >
            </is-igx-mapping>
        </div>
    </div>
</div>
